export function getString(str, component = 'moodle') {
    return window.M.str[component][str];
}
